// <delivery-estimate> (§0.1.1): «Llega entre el [fecha] y el [fecha]», saltando fines de semana y festivos.
// Solo con el plazo confirmado por el proveedor; si no, no pinta nada (el texto de al lado muestra el marcador).
// La frase llega en data-template (products.delivery_range del archivo de idioma) con los huecos {{ start }} y {{ end }}.
import { estimateDelivery, formatDay } from './delivery-logic.js';

const HOLE = /(\{\{\s*(?:start|end)\s*\}\})/;

class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    let holidays = [];
    try {
      holidays = JSON.parse(this.dataset.holidays || '[]');
    } catch {
      holidays = [];
    }
    const range = estimateDelivery(new Date(), { minDays: this.dataset.min, maxDays: this.dataset.max, holidays, confirmed: this.dataset.confirmed === 'true' });
    const template = this.dataset.template ?? '';
    if (!range || !template) return;
    const p = document.createElement('p');
    for (const part of template.split(HOLE)) {
      if (!part) continue;
      const hole = part.match(/^\{\{\s*(start|end)\s*\}\}$/);
      if (hole) {
        const day = document.createElement('strong');
        day.textContent = formatDay(hole[1] === 'start' ? range.from : range.to);
        p.append(day);
      } else {
        p.append(part);
      }
    }
    this.replaceChildren(p);
  }
}

customElements.define('delivery-estimate', DeliveryEstimate);
